import { useEffect } from "react";
import "./App.css";
import MainLayoutSubmitter from "./Layout/MainLayoutSubmitter";
import MainRoutesSubmitter from "./Routes/MainRoutesSubmitter/MainRoutesSubmitter";
import { GetJsonData } from "./Redux/Reducers/Shared/FetchDataJson";
import { useDispatch, useSelector } from "react-redux";
import LogInServices from "./Services/Account/LogInServices";
import "./Assets/SharedStyle/style.css";
import LoaderAHSF from "./Components/LoaderAHSF";
import { initializeApiClient } from "./Services/Api/ApiServices";
import { Decrypt } from "./Redux/Reducers/Shared/Encryption";
import { jwtDecode } from "jwt-decode";
import { SetDataUser } from "./Redux/Reducers/Shared/UserInfo";
import { GetActiveRound } from "./Redux/Reducers/Shared/ApplicationInformation";
import MainLayoutManager from "./Layout/MainLayoutManager";
import MainRoutsManager from "./Routes/MainRoutesManager/MainRoutsManager";
import { GetEV_ST_RouteManagerList } from "./Redux/Reducers/Manager/RouteManager";
import AccessDeniedPage from "./Pages/Shared/AccessDeniedPage";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import SAMLLoginPage from "./Pages/Shared/HomePageManager";

function App() {
  const navigate = useNavigate();
  let location = useLocation();
  const resultJson = useSelector((state) => state.FetchDataJson.JsonData);
  const activeRound = useSelector(
    (state) => state.ApplicationInformation.ActiveRound
  );
  const UserInfo = useSelector((state) => state.UserInfo.UserInfo);
  const globalLoding = useSelector(
    (state) => state.globalLoading.pendingRequests
  );

  const lang = useSelector((state) => state.languageReducer.Language);

  // document.style.fontSize = 100 + "rem";
  const RouteManagerList = useSelector(
    (state) => state.RouteManagerReducer.RouteManager
  );
  console.log(resultJson, "resultJson");


  // console.log(UserInfo.userType=="submitter","ddddddfefef");
  // var a=window.Chatling;
  //   useEffect(() => {
  //     if(UserInfo.userType=="submitter"){
  //       a?.hideChatIcon();
  //     }
  //   }, [a,UserInfo]);

useEffect(() => {
  if (UserInfo?.userType === "submitter") {
    window.chtlConfig = { chatbotId: "3676768382" };

    const script = document.createElement("script");
    script.src = "https://chatling.ai/js/embed.js";
    script.async = true;
    script.dataset.id = "3676768382";
    script.id = "chtl-script";

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }
}, [UserInfo]);


// ========= تغيير اللغة والنص ==========
useEffect(() => {
  // تحديث اللغة
  window.chtlConfig = {
    ...window.chtlConfig,
    language: lang === "en" ? "en" : "ar",
  };

  // محاولة تغيير النص بعد ظهور العنصر
  const interval = setInterval(() => {
    const elements = document.querySelectorAll(
      ".chtl-hovering-message-container p"
    );

    if (elements.length > 0) {
      elements.forEach((el) => {
        el.textContent =
          lang === "ar"
            ? resultJson?.ChatboxtextAr
            : resultJson?.ChatboxtextEn;
      });

      clearInterval(interval); // وقف البحث عند إيجاد العناصر
    }
  }, 300);

  return () => clearInterval(interval);
}, [lang, resultJson]);
  // const elements = document.querySelectorAll(
  //   ".chtl-hovering-message-container p"
  // );
  // elements.forEach((el) => {
  //   el.textContent =
  //     lang === "ar" ? resultJson.ChatboxtextAr : resultJson.ChatboxtextEn;
  // });
  // console.log(elements); // NodeList of elements
  // console.log(lang, "gggggggggggggggggggggggggg"); // NodeList of elements

  useEffect(() => {
    dispatch(GetEV_ST_RouteManagerList());
  }, []);
  const dispatch = useDispatch();
  //   console.log(UserInfo?.roles
  // , "sssssssssssssssssssss ");
  // console.log(JSON.parse(UserInfo?.roles)?.map(role=>role.RolesId), "sssssssssssssssssssss ");
  const logIn = async () => {
    let userInfo = await LogInServices();
    // dispatch(SetDataUser(userInfo));
    // dispatch(SetLogin(userInfo.login));
    // setLoginStatus(userInfo.login);
  };
  useEffect(() => {
    const initApi = async () => {
      await initializeApiClient("application/json");
    };
    initApi();
  }, []); // فاضي = مرة وحدة فقط
  useEffect(() => {
    console.log(resultJson, "efefefef");

    if (!resultJson?.client_id) {
      dispatch(GetJsonData());
    }
  }, [dispatch]);
  const setTokenManger = async () => {
    const params = new URLSearchParams(window.location.search);

    // Get the value of "token"
    const token = params.get("token");
    console.log(token, "sssssssdswdsdsdssssss");
    // ();

    if (token) {
      sessionStorage.setItem("AccessTokenManager", token);
      var resultToken = await dispatch(
        Decrypt({ encryptValue: token, isEncoding: true })
      );
      console.log(resultToken?.payload, "resultToken");

      if (resultToken?.payload != null || resultToken?.payload != undefined) {
        const decodedToken = jwtDecode(resultToken.payload);
        if (UserInfo == null || UserInfo == undefined) {
          dispatch(SetDataUser(decodedToken));
        }
      }
    }
  };
  useEffect(() => {
    setTokenManger();
    if (
      resultJson?.internalssoUrlEvaluationLogin != null &&
      resultJson?.internalssoUrlEvaluationLogin != undefined
    ) {
      if (
        location?.pathname.split("/").includes("manager") == true ||
        location?.pathname.split("/").includes("Manager") == true
      ) {
        if (
          location?.pathname.split("/").includes("Evaluation") == true ||
          location?.pathname.split("/").includes("evaluation") == true
        ) {
          if (sessionStorage.getItem("AccessTokenManager") == null) {
            window.location.replace(resultJson?.internalssoUrlEvaluationLogin);
          }
        } else if (
          location?.pathname.split("/").includes("Scientific") == true ||
          location?.pathname.split("/").includes("scientific") == true
        ) {
          if (sessionStorage.getItem("AccessTokenManager") == null) {
            window.location.replace(resultJson?.internalssoUrlEvaluationLogin);
          }
        } else {
          if (sessionStorage.getItem("AccessTokenManager") == null) {
            navigate(`/ResearchersAward/manager/SAMLLoginPage/`);
            // window.location.replace(resultJson?.internalssoUrlManagerLogin);
          }
        }

        // if(){

        // }
      }
      //changes
      // else if (window.location.pathname.includes("manager") !== true) {
      //   logIn();
      // }
      else if (!window.location.pathname.includes("manager")) {
        logIn(); // Researcher login ONLY
      }
    }
  }, [resultJson]);
  useEffect(() => {
    dispatch(
      GetActiveRound({
        applicationInformationId: localStorage.getItem(
          "ApplicationInformationId"
        ),
        locationManager: window.location.href.includes("manager"),
      })
    );
  }, [localStorage.getItem("ApplicationInformationId")]);
  const DecryptToken = async () => {
    // Get the current URL
    const url = window.location.href;

    // Create a URL object

    if (sessionStorage.getItem("AccessToken")) {
      var resultToken = await dispatch(
        Decrypt({
          encryptValue: sessionStorage.getItem("AccessToken"),
          isEncoding: true,
        })
      );
      console.log(resultToken?.payload, "resultToken");

      if (resultToken?.payload != null || resultToken?.payload != undefined) {
        const decodedToken = jwtDecode(resultToken.payload);
        if (UserInfo == null || UserInfo == undefined) {
          dispatch(SetDataUser(decodedToken));
        }
      }
    }
  };
  // console.log(JSON.parse(UserInfo?.roles), "ddddddddddddddddddfe");
  console.log(
    sessionStorage.getItem("AccessTokenManager"),
    "sssssssssssssssdwdwd"
  );
  //changes
  // useEffect(() => {
  //   DecryptToken();
  // }, []);

  useEffect(() => {
    if (!window.location.pathname.includes("manager")) {
      DecryptToken(); // Researcher ONLY
    }
  }, []);

  if (
    resultJson == null ||
    resultJson == undefined ||
    resultJson == "undefined"
  ) {
    // console.log("dddddddfefefefef");

    return <></>;
  }

  if (
    (location?.pathname.split("/").includes("manager") == true ||
      location?.pathname.split("/").includes("Manager") == true) &&
    sessionStorage.getItem("AccessTokenManager") == null
  ) {
    return (
      <>
        <Routes>
          <Route
            path="/ResearchersAward/manager/SAMLLoginPage/"
            element={<SAMLLoginPage />}
          />
        </Routes>
      </>
    );
  }
  // if (
  //   activeRound == null ||
  //   activeRound == undefined ||
  //   activeRound == "undefined"
  // ) {
  //     console.log("dddddddfefefefef");

  //   return <></>;
  // }

  // console.log(
  //   JSON.parse(UserInfo?.roles)?.map((role) => role.RoleId),
  //   "ssssssssssssdwwd"
  // );
  //changes
  // if (UserInfo != null || UserInfo != undefined)
  if (UserInfo !== null && UserInfo !== undefined) {
    // console.log("dddddddfefefefef");

    if (
      JSON.parse(UserInfo?.roles)
        ?.map((role) => role.RolesId)
        .includes("29dc7aca-7add-48c4-b0a2-5307c0cd0bc4")
    ) {
      return (
        <div className="App">
          {(globalLoding > 0 ||
            sessionStorage.getItem("AccessToken") === null ||
            activeRound == null ||
            activeRound == undefined) && <LoaderAHSF show={true} />}
          <MainLayoutSubmitter>
            <MainRoutesSubmitter />
          </MainLayoutSubmitter>
        </div>
      );
    } else if (
      JSON.parse(UserInfo?.roles).length > 0 &&
      RouteManagerList != undefined &&
      RouteManagerList.length > 0
    ) {
      // console.log("dddddddfefefefef");

      return (
        <MainLayoutManager>
          <MainRoutsManager />
        </MainLayoutManager>
      );
    } else if (JSON.parse(UserInfo?.roles).length == 0) {
      // console.log("dddddddfefefefef");

      return <AccessDeniedPage />;
    }
  }

  //  {
  //   <script>
  //   window.chtlConfig = { chatbotId: "9484596775" };
  // </script>
  // <script async data-id="9484596775" id="chtl-script" type="text/javascript" src="https://chatling.ai/js/embed.js"></script>
  //  }
}

export default App;
